import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CountriesService } from '../../admin/countries/countries.service';
import {
  loadHelpDocuments,
  loadHelpDocumentsFailure,
  loadHelpDocumentsSuccess,
} from './help-documents.actions';

@Injectable()
export class HelpDocumentsEffects {
  private readonly actions$ = inject(Actions);
  private readonly countriesService = inject(CountriesService);

  public loadHelpDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadHelpDocuments),
      switchMap(() =>
        this.countriesService.getCountryHelpDocumentsByProfile().pipe(
          map((documents) => loadHelpDocumentsSuccess({ documents })),
          catchError(() => of(loadHelpDocumentsFailure()))
        )
      )
    )
  );
}
